import { render } from "./HospitalPhysicianEdit.vue?vue&type=template&id=091a4ffa"
import script from "./HospitalPhysicianEdit.vue?vue&type=script&lang=js"
export * from "./HospitalPhysicianEdit.vue?vue&type=script&lang=js"

import "./HospitalPhysicianEdit.vue?vue&type=style&index=0&id=091a4ffa&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/physicians/HospitalPhysicianEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "091a4ffa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('091a4ffa', __exports__)) {
    console.log('reload')
    api.reload('091a4ffa', __exports__)
  }
  
  module.hot.accept("./HospitalPhysicianEdit.vue?vue&type=template&id=091a4ffa", () => {
    console.log('re-render')
    api.rerender('091a4ffa', render)
  })

}


export default __exports__